import classNames from "classnames/bind";
import { SimpleArrowDownIcon } from "common/assets/icons/SimpleArrowDownIcon";
import { SimpleArrowUpIcon } from "common/assets/icons/SimpleArrowUpIcon";
import { H5, SubText } from "common/components/Typography";
import { useToggle } from "common/hooks/useToggle";
import * as React from "react";
import { ReactNode } from "react";
import styles from "./ExpandableItem.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  title: string;
  subText?: string;
  defaultExpanded?: boolean;
  content: ReactNode;
}

export const ExpandableItem: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  subText,
  defaultExpanded = false,
  content,
}) => {
  const [isExpanded, setIsExpanded] = useToggle(defaultExpanded);

  const headerStyles = classNameBuilder({
    header: true,
    paddingBottom: isExpanded,
  });

  return (
    <section className={styles.container}>
      <button type="button" onClick={setIsExpanded} className={headerStyles}>
        <div>
          <H5 withSpacing={false}>{title}</H5>
          <SubText>
            <b>{subText}</b>
          </SubText>
        </div>
        <span>
          {isExpanded ? (
            <SimpleArrowUpIcon withBackground />
          ) : (
            <SimpleArrowDownIcon withBackground />
          )}
        </span>
      </button>
      {isExpanded && content}
    </section>
  );
};
